import {
  AuthenticatedCollectionFormModel,
  PermissionModel,
} from '../permissions';

export class SharedCollectionPresenterModel {
  id: string;
  dataEntity: string;
  authenticated?: AuthenticatedCollectionFormModel;
  sharedTo?: Array<PermissionModel>;
}
